<template>
  <div id="create_vd_card_page" class="page-wrapper">
    <section class="page-title">
      <div class="go-back" @click="goback()">
        <img
          src="@/assets/images/back-arrow-btn.svg"
          class="icon-back"
          alt="back"
        />
      </div>
      {{ lbl.value_design.create_card.page_title }}
    </section>
    <section class="card-wrapper">
      <div
        v-for="card in cardTypeList"
        :key="card.id"
        class="card-container"
        @click="createCard(card.id)"
      >
        <img :src="card.icon" :alt="card.id" />
        <div class="detail">
          <strong>{{ card.title }}</strong>
          <span>{{ card.desc }}</span>
        </div>
      </div>
      <div class="remark">
        <strong>
          {{ lbl.value_design.create_card.remark.title }}
        </strong>
        <div class="desc">
          <span>
            {{ lbl.value_design.create_card.remark.desc }}
          </span>
          <strong>
            {{ lbl.value_design.create_card.remark.bold }}
          </strong>
          <span>
            {{ lbl.value_design.create_card.remark.desc2 }}
          </span>
        </div>
      </div>
    </section>
    <AlertCreateModal
      :show="alert.show"
      :success="alert.success"
      :title="alert.title"
      :desc="alert.desc"
      :type="'digital'"
    />
  </div>
</template>

<script>
import Account from '@/helper/AccountHelper.js'
import AlertCreateModal from '@/module/ValueDesign/components/AlertCreateModal'
import BzbsVD from '@/core/ValueDesign/BzbsValueDesign.js'
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
export default {
  name: 'CreateCard',
  components: {
    AlertCreateModal,
  },
  mixins: [CommonMixin, ResponsiveMixin],
  data() {
    return {
      previousRoute: null,
      cardTypeList: [],
      alert: {
        show: false,
        success: false,
        title: '',
        desc: '',
      },
    }
  },
  created() {
    Account.bzbsAnalyticTracking(
      'create_vd_card_page',
      'create_vd_card_page',
      'view_create_vd_card_page',
      'on view',
    )
    this.handleLoading(false)
    this.handleFooter(false)
    this.handleLanguage(true)

    this.init()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from
      console.log('Previous route:', vm.previousRoute)
    })
  },
  methods: {
    init() {
      this.getCardTypeListData()
    },
    getCardTypeListData() {
      this.cardTypeList = [
        {
          id: 'digital',
          title: this.lbl.value_design.create_card.digital.title,
          desc: this.lbl.value_design.create_card.digital.desc,
          icon: require(`../../assets/images/valueDesign/digital_card_icon.svg`),
        },
        {
          id: 'physical',
          title: this.lbl.value_design.create_card.physical.title,
          desc: this.lbl.value_design.create_card.physical.desc,
          icon: require(`../../assets/images/valueDesign/physical_card_icon.svg`),
        },
      ]
    },
    goback() {
      Account.bzbsAnalyticTracking(
        `add_card_page`,
        `value_design`,
        'click_go_back',
        'on click',
      )
      console.log('b4 this.$router.go(-1)', this.previousRoute) //;
      if (this.previousRoute.name === 'createPhysicalCard') {
        if (this.$route.query.from) {
          this.$router.push({ name: this.$route.query.from }) //
        } else {
          this.$router.push({ name: 'home' }) //
        }
      } else {
        this.$router.go(-1)
      }
    },
    createCard(type) {
      Account.bzbsAnalyticTracking(
        `add_card_page`,
        `value_design`,
        `click_create_card_${type}`,
        'on click',
      )
      switch (type) {
        case 'digital':
          this.createDigitalCard()
          break
        case 'physical':
          this.$router.push({
            name: 'createPhysicalCard',
            query: {
              from: this.previousRoute.name ? this.previousRoute.name : null,
            },
          })
          break
      }
    },
    createDigitalCard() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsVD.createDigitalCard()
          .then(res => {
            this.handleLoading(false)
            if (res.data.success) {
              Account.bzbsAnalyticTracking(
                `add_card_page`,
                `value_design`,
                'add_card_success',
                'on view',
              )
              this.alert = {
                show: true,
                success: true,
                title: this.lbl.value_design.create_card.modal_alert
                  .success_title,
                desc: this.lbl.value_design.create_card.modal_alert
                  .success_desc,
              }
            } else {
              Account.bzbsAnalyticTracking(
                `add_card_page`,
                `value_design`,
                'add_card_fail',
                'on view',
              )
              if (res.data.message === 'Card already exist') {
                this.alert = {
                  show: true,
                  success: false,
                  title: this.lbl.value_design.create_card.modal_alert
                    .fail_exist_title,
                  desc: this.lbl.value_design.create_card.modal_alert
                    .fail_exist_desc,
                }
              } else if (res.data.message === 'Card is not found') {
                this.alert = {
                  show: true,
                  success: false,
                  title: this.lbl.value_design.create_card.modal_alert
                    .fail_not_found_title,
                  desc: this.lbl.value_design.create_card.modal_alert
                    .fail_not_found_desc,
                }
              } else {
                this.alert = {
                  show: true,
                  success: false,
                  title: res.data.message,
                  desc: null,
                }
              }
            }
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            Account.bzbsAnalyticTracking(
              `add_card_page`,
              `value_design`,
              'add_card_fail',
              'on view',
            )
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            resolve(error)
          })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.page-wrapper {
  max-width: 820px;
  margin: auto;
  padding: 0px 20px 50px;
  .page-title {
    font-size: 28px;
    font-weight: 500;
    color: #212121;
    margin: 10px auto;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
    .go-back {
      width: 42px;
      height: 42px;
      border-radius: 100px;
      border: 1px solid #eeeeee;
      background-color: #ffffff;
      box-shadow: 0px 4px 10px 0px #0000001a;
      display: flex;
      align-items: center;
      justify-content: center;

      .icon-back {
        width: 16px;
      }
    }
  }
  .card-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    .card-container {
      padding: 24px 16px;
      border-radius: 12px;
      border: 1px solid #c9c9c9;
      display: flex;
      gap: 16px;

      img {
        width: 100px;
        height: 100px;
      }
      .detail {
        display: flex;
        flex-direction: column;
        gap: 4px;
        strong {
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
          color: #4a4a4a;
        }
        span {
          font-size: 14px;
          font-weight: 400;
          line-height: 21px;
          color: #636363;
        }
      }
    }
    .remark {
      position: fixed;
      left: 0;
      bottom: 56px;
      display: flex;
      flex-direction: column;
      padding: 16px;
      gap: 4px;

      strong {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        color: #4a4a4a;
      }
      .desc {
        font-size: 14px;
        line-height: 21px;
        color: #636363;

        strong {
          font-weight: 700;
        }
      }
    }
  }
}
</style>
